import script from "./BackToTopButton.vue?vue&type=script&setup=true&lang=js"
export * from "./BackToTopButton.vue?vue&type=script&setup=true&lang=js"

import "./BackToTopButton.vue?vue&type=style&index=0&id=4ddac79d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ddac79d"]])

export default __exports__